// import Vue from 'vue';
import axios from 'axios';
import swal from 'sweetalert2';
import { Toast } from './globals';

const AUTH_URLS = [
  'api/auth/login',
  'api/auth/register',
  'api/auth/verify',
  'api/auth/forgotten-password',
  'api/auth/set-password'
];

// Zahtevki v ozadju, kjer napaka uporabnika ne zanima.
const SILENT_URLS = ['view-tracker'];

const MUTATING_METHODS = ['post', 'put', 'patch', 'delete'];

function isAuthUrl(url) {
  return AUTH_URLS.some(authUrl => (url ? url.includes(authUrl) : false));
}

function isSilentUrl(url) {
  return SILENT_URLS.some(silentUrl => (url ? url.includes(silentUrl) : false));
}

/**
 * Berljivo sporočilo napake iz odgovora API-ja.
 * NestJS vrne sporočilo kot niz ali kot polje nizov (validacijske napake).
 */
export function apiErrorMessage(error) {
  const response = error ? error.response : null;
  const data = response ? response.data : null;
  let message = data ? (data.message || data.error) : null;

  if (Array.isArray(message)) {
    message = message.join('<br/>');
  }

  if (!message) {
    message = error && error.message ? error.message : 'Neznana napaka.';
  }

  // Status koda mocno olajsa ugotavljanje vzroka ob prijavi napake.
  return response && response.status ? `${response.status} - ${message}` : message;
}

export default function setup() {
  axios.interceptors.request.use(_config => {
    const token = localStorage.getItem("jwt") ? localStorage.getItem("jwt") : null;
    console.log("_config", _config);
    if(token && (!_config.url.includes('api/auth/login') && !_config.url.includes('api/auth/register') && !_config.url.includes('api/auth/verify') && !_config.url.includes('api/auth/forgotten-password'))) {
        _config.headers.common["Authorization"] = "Bearer " + token;
    }
    return _config
  }, error => {
    return Promise.reject(error)
  })

  axios.interceptors.response.use(response => response, error => {
    const config = error && error.config ? error.config : {};
    const status = error && error.response ? error.response.status : null;
    const method = config.method ? config.method.toLowerCase() : '';

    // Na voljo stranem, ki napako prikažejo same.
    error.userMessage = apiErrorMessage(error);

    if (isAuthUrl(config.url)) {
      return Promise.reject(error);
    }

    // Seja je potekla ali žeton ni več veljaven - uporabnika je treba obvestiti,
    // sicer izgleda, kot da gumbi ne delajo.
    if (status === 401) {
      localStorage.removeItem("jwt");
      localStorage.removeItem("user");

      swal.fire({
        title: 'Vaša seja je potekla',
        icon: 'warning',
        html: 'Prosimo, ponovno se prijavite in poskusite znova.',
        confirmButtonText: 'OK'
      }).then(() => {
        window.location.href = '/';
      });

      return Promise.reject(error);
    }

    // Zahtevki, ki spreminjajo podatke, ne smejo tiho spodleteti. Strani, ki napako
    // prikažejo same, pošljejo v konfiguraciji `handledLocally: true`.
    if (!config.handledLocally && !isSilentUrl(config.url) && MUTATING_METHODS.includes(method)) {
      Toast.fire({
        icon: 'error',
        timer: 8000,
        title: 'Podatki niso bili shranjeni!',
        html: error.userMessage
      });
    }

    return Promise.reject(error)
  })
}
